export default __webpack_public_path__ + "2e7b7b0b5a2232e0e3b2c74dcaa34aac.png";